import { useCallback } from 'react';
import Lookup from '../componentes/select-async';
import ColaboradorList from 'src/paginas/colaborador/ColaboradorLookup';
import Avatar from '../componentes/item-multi-lookup';
import { UncontrolledTooltip } from 'reactstrap';

const ColaboradorLookup = (props) => {
  const renderColaborador = useCallback(
    (item) => {
      const isValid =
        item.value &&
        (typeof item.value === 'object'
          ? item.value.id
          : item.value.length > 0);

      return (
        <>
          {isValid && (
            <Avatar
              foto={item?.value?.fotoArquivo}
              size={props.size}
              onlyAvatar={props.onlyAvatar}
              disabled={props.disabled}
              avatar
              label={item.value.nome}
              onRemove={item.onRemove && (() => item.onRemove(item.value))}
              value={item.value}
              multi={props.multi}
            />
          )}
        </>
      );
    },
    [props]
  );

  const somenteAtivos = props.data
    ? props.data.somenteAtivos
    : !props.exibirInativos;

  const {
    selecionarAvaliador,
    processoAvaliativoId,
    avaliadoId,
    showHint,
    hint,
    optionRenderer,
  } = props;

  return (
    <div id="lkpcolaborador-hint">
      <Lookup
        valueComponent={renderColaborador}
        valueKey="id"
        labelKey="nome"
        showSearch
        clearable
        url="/ColaboradorLookup"
        searchComponent={ColaboradorList}
        showConfirmButton={false}
        {...props}
        optionRenderer={optionRenderer}
        data={{
          ...props.data,
          viewListSearch: true,
          somenteAtivos,
          carregarPodeSerAvaliador: selecionarAvaliador,
          processoAvaliativoId,
          avaliadoId,
        }}
      />

      {showHint && (
        <UncontrolledTooltip placement="auto" target="lkpcolaborador-hint">
          {hint}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

export default ColaboradorLookup;
